import React, { useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import { Card } from 'antd';
import { Button } from '../../../components/button';
import { IsActiveSwitch } from '../../../components/is-active-switch';
import { useUnsavedChanges } from '../../../contexts/unsaved-changes';
import { CarwashCustomerServiceStatus } from '../../../types';
import style from './style.module.scss';

const { Meta } = Card;

interface Props {
    isLoading: boolean;
    isUpdating: boolean;
    carwashCustomerServiceStatus: CarwashCustomerServiceStatus | null;
    onSubmit: (conf: CarwashCustomerServiceStatus) => void;
}

export const CarwashCustomerServiceStatusCard = (props: Props) => {
    const valuesSnapshot = React.useRef<null | CarwashCustomerServiceStatus>(
        null
    );
    const formik = useFormik<CarwashCustomerServiceStatus>({
        initialValues: {
            status: 'inactive',
        },
        onSubmit: props.onSubmit,
    });

    const handleSaveFromModal = useCallback(async () => {
        await formik.submitForm();
    }, [formik]);

    useUnsavedChanges({ dirty: formik.dirty, onSave: handleSaveFromModal });

    useEffect(() => {
        if (props.carwashCustomerServiceStatus) {
            valuesSnapshot.current = props.carwashCustomerServiceStatus;
            formik.resetForm({ values: props.carwashCustomerServiceStatus });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.carwashCustomerServiceStatus]);

    const hasChanged = () => {
        return formik.values.status !== valuesSnapshot.current?.status;
    };

    return (
        <Card bordered={false} loading={props.isLoading} className={style.card}>
            <Meta title="CUSTOMER SERVICE CONFIGURATION" />
            <form className={style.card_content}>
                <div>
                    <IsActiveSwitch
                        values={formik.values}
                        title="Customer service phone button visibility"
                        onChange={(values) => {
                            formik.setValues({
                                ...formik.values,
                                ...values,
                            });
                        }}
                    />
                </div>
                <Button
                    variant="primary"
                    disabled={!hasChanged()}
                    loading={props.isUpdating}
                    onClick={() => formik.submitForm()}
                >
                    Save
                </Button>
            </form>
        </Card>
    );
};
